import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton, FadeIn } from './ui';
export function Hero() {
  return <section className="relative pt-20 pb-24 px-4 overflow-hidden flex flex-col items-center text-center" data-id="element-68">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-orange/10 rounded-full blur-[120px] pointer-events-none" data-id="element-69" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-70">
        <FadeIn data-id="element-71">
          <div className="inline-block bg-brand-orange/20 border border-brand-orange/50 text-brand-gold px-4 py-1.5 rounded-full text-sm font-bold tracking-widest uppercase mb-8" data-id="element-72">
            Atención Padres y Madres Hispanos en USA
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-73">
          <h1 className="font-bebas text-5xl md:text-7xl lg:text-8xl leading-[0.9] text-white mb-8 drop-shadow-2xl" data-id="element-74">
            Cómo Recuperar la Energía de tus{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-gold to-brand-orange" data-id="element-75">
              22 Años
            </span>{' '}
            en Solo 30 Días
          </h1>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-76">
          <p className="text-xl md:text-3xl font-bebas text-zinc-300 mb-8 max-w-3xl mx-auto leading-tight" data-id="element-77">
            Sin Dejar tu Cafecito y sin Suplementos Elitistas — Incluso si
            Trabajas 'Overtime' y Llegas a Casa Molido.
          </p>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-78">
          <p className="text-lg md:text-xl text-zinc-400 mb-12 max-w-2xl mx-auto font-medium" data-id="element-79">
            El primer protocolo de Biohacking diseñado exclusivamente para el
            padre y la madre hispana en Estados Unidos que están cansados de
            sentirse como zombies en el país de las oportunidades.
          </p>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-80">
          <CTAButton data-id="element-81" />
          <p className="mt-4 text-sm text-zinc-500 flex items-center justify-center gap-2" data-id="element-82">
            <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-83" />
            Oferta válida hasta medianoche
          </p>
        </FadeIn>
      </div>
    </section>;
}